import { isDialCountryIsoSupported } from "../countryDialOptions";

/**
 * Cloudflare Pages serves `functions/client-country.js` at GET `/client-country`.
 * Local CRA dev has no Worker — request falls through to HTML; we return null and keep UI default (GB).
 *
 * @returns {Promise<string | null>} ISO alpha-2 if detected and supported, else null
 */
export async function fetchSuggestedSignupCountryIso() {
  if (typeof window === "undefined") return null;
  try {
    const res = await fetch(`${window.location.origin}/client-country`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return null;
    const ct = res.headers.get("content-type") || "";
    if (!ct.includes("application/json")) return null;
    const data = await res.json();
    const c = String(data.country || "")
      .trim()
      .toUpperCase();
    if (!/^[A-Z]{2}$/.test(c) || !isDialCountryIsoSupported(c)) return null;
    return c;
  } catch {
    return null;
  }
}
